const { DEV, GLOBAL } = require('../constant');
const config = require('./config');

module.exports = {
  ...config,
  i18nPath: `${process.env.i18nPath}/i18n/api/v1/dev`,
  buildEnv: DEV,
  site: GLOBAL,
};
